import * as C from "./styles";
import React from "react";
import { COLOR_ADEGA_RED, spacing } from "../../config";
import * as yup from "yup";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Login, LoginServerResponse } from "../../types/authTypes";
import { toast } from "react-toastify";
import { useAuthenticateMutation } from "../../redux/api/api";
import { Payload } from "../../types/rtkTypes";
import { Navigate, useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import FlexContainer from "../../components/FlexContainer";
import FormInput from "../../components/FormInput";
import FormButton from "../../components/FormButton";

const schema = yup.object().shape({
  cnpj: yup
    .string()
    .typeError("Valor inválido")
    .required("O campo é obrigatório!")
    .test("cpf ou cnpj", "Insira um CPF ou CNPJ válido", (value) => {
      if (
        value?.match(/\d{3}\.\d{3}\.\d{3}\-\d{2}/) ||
        value?.match(/\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}/)
      ) {
        return true;
      } else {
        return false;
      }
    }),
  password: yup
    .string()
    .typeError("Valor inválido")
    .required("O campo é obrigatório!"),
});

export default function LoginPage() {
  const tipos = ["1", "2", "3", "5", "8", "15", "18", "21", "24"];
  const [auth, authResults] = useAuthenticateMutation();
  const [disableButton, setDisableButton] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const { user } = useSelector((store: RootState) => store.user);
  console.log(user);
  const methods = useForm<Login>({ resolver: yupResolver(schema) });
  const [inputType, setInputType] = React.useState<string>("");

  const cnpjMask = (value: string) => {
    return value
      .replace(/\D+/g, "")
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  };

  function cpfMask(value: string) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  }

  React.useEffect(() => {
    if (methods.watch("cnpj")?.length > 14) {
      methods.setValue("cnpj", cnpjMask(methods.watch("cnpj")));
    } else if (methods.watch("cnpj")?.length <= 14) {
      methods.setValue("cnpj", cpfMask(methods.watch("cnpj")));
    }

    if (methods.watch("cnpj")?.match(/\d{3}\.\d{3}\.\d{3}\-\d{2}/)) {
      setInputType("CPF");
    } else if (
      methods.watch("cnpj")?.match(/\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}/)
    ) {
      setInputType("CNPJ");
    } else {
      setInputType("CPF/CNPJ");
    }
  }, [methods.watch("cnpj")]);

  React.useEffect(() => {
    let invalidAuth = localStorage.getItem("invalidAuth") ?? "";
    if (invalidAuth && invalidAuth === "bloqueado") {
      toast.info(
        "Você não possui acesso ao sistema. Contate um administrador para desbloqueio e/ou sanar eventuais pendências."
      );
      localStorage.setItem("invalidAuth", "");
    }
  }, []);

  const onSubmit = (data: Login) => {
    auth(data)
      .unwrap()
      .then((payload: unknown) => {
        console.log(payload);

        setDisableButton(true);
        localStorage.setItem(
          "token",
          (payload as LoginServerResponse).token ?? ""
        );
        toast.success("Autenticado com sucesso!");

        navigate(0);
      })
      .catch((err: unknown) => {
        if ((err as Payload<LoginServerResponse>).status === "FETCH_ERROR") {
          toast.error("Erro de conexão!");
        } else if ((err as Payload<LoginServerResponse>).status === 401) {
          toast.error("Credenciais inválidas!");
        }
      });
  };

  if (user.TIPO && tipos.find((item) => item == user.TIPO)) {
    return <Navigate to={`/${user.TIPO}/agendar`} />;
  } else {
    return (
      <C.LoginPageContainer>
        <C.LeftSide>
          <C.BocchiLogo />
        </C.LeftSide>
        <C.RightSide>
          <C.LoginLogo />
          <FormProvider {...methods}>
            <C.LoginForm onSubmit={methods.handleSubmit(onSubmit)}>
              <FormInput
                error={!!methods.formState.errors.cnpj}
                errorMsg={methods.formState.errors.cnpj?.message}
                formName="cnpj"
                placeholder={inputType}
                type="text"
              />
              <FormInput
                error={!!methods.formState.errors.password}
                errorMsg={methods.formState.errors.password?.message}
                formName="password"
                type="password"
                placeholder={"Senha"}
              />

              <FormButton
                disabled={disableButton}
                text="autenticar"
                customStyle={{ marginTop: spacing(5) }}
              />
            </C.LoginForm>
          </FormProvider>
          <C.BottomBar className="bottom-bar">
            <C.BottomBarText>
              PSA Aplicativos - Desenvolvido por Rian Da Costa Lima
            </C.BottomBarText>
          </C.BottomBar>
        </C.RightSide>
      </C.LoginPageContainer>
    );
  }
}
